<template>
  <ion-page>
    <ion-tabs>
      <ion-router-outlet></ion-router-outlet>
      <ion-tab-bar slot="bottom">
        <ion-tab-button tab="informations" href="/quiz/activitee1">
          <ion-icon class="puce-logo" :src="require('@/assets/quizbutton-icons/icon_text_a_trou.svg')"></ion-icon>
        </ion-tab-button>

        <ion-tab-button tab="act1" href="/quiz/activitee2">
          <ion-icon class="puce-logo" :src="require('@/assets/quizbutton-icons/icon_def_image.svg')"></ion-icon>
        </ion-tab-button>

        <ion-tab-button tab="act2" href="/quiz/activitee3">
          <ion-icon class="puce-logo" :src="require('@/assets/quizbutton-icons/icon_choix_metiers.svg')"></ion-icon>
        </ion-tab-button>

        <ion-tab-button tab="act3" href="/quiz/activitee4">
          <ion-icon class="puce-logo" :src="require('@/assets/quizbutton-icons/icon_favoris.svg')"></ion-icon>
        </ion-tab-button>

        <!--<ion-tab-button tab="act4" @click="this.$router.push('activitee5')">
          <ion-icon class="puce-logo" :src="require('@/assets/quizbutton-icons/icon_information.svg')"></ion-icon>
        </ion-tab-button>-->
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script>

import {defineComponent} from "vue";
import {IonTabs, IonTabButton, IonTabBar, IonRouterOutlet, IonIcon, IonPage} from "@ionic/vue";

export default defineComponent({
  components: {IonPage, IonIcon, IonTabs, IonTabButton, IonTabBar, IonRouterOutlet }
})
</script>
